import { Router as WouterRouter, Route } from 'wouter-preact'
import { Suspense } from 'preact/compat'
import { TermsPage } from '@/pages/terms-page/TermsPage'
import { DocumentAddPage } from '@/pages/DocumentAdd'
import { SummaryPage } from '@/pages/Summary'
import { QrCodePage } from '@/pages/QrCode'
import { WaitingForSignaturePage } from '@/pages/WaitingForSignature'
import { SessionExpiredPage } from '@/pages/SessionExpired'
import { ProcessErrorPage } from '@/pages/ProcessError'
import { ProtectedRoute, PageLoaderProvider } from '@/components'
import { useNavigationGuard } from '@/services/navigation-guard'
import { ConfigProvider } from '@/services/config'

// Loading component for Suspense boundaries
function PageLoader() {
  return (
    <div className='min-h-screen bg-white flex items-center justify-center'>
      <div className='text-center'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-cencert-blue mx-auto mb-1'></div>
        <p className='text-gray-600'>Loading...</p>
      </div>
    </div>
  )
}

function NavigationGuard() {
  useNavigationGuard()
  return null
}

export function Router() {
  return (
    <PageLoaderProvider>
      <ConfigProvider>
        <WouterRouter>
          <NavigationGuard />
          <Suspense fallback={<PageLoader />}>
            <Route
              path='/'
              component={() => (
                <ProtectedRoute>
                  <TermsPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path='/add-document'
              component={() => (
                <ProtectedRoute>
                  <DocumentAddPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path='/qr-code'
              component={() => (
                <ProtectedRoute>
                  <QrCodePage />
                </ProtectedRoute>
              )}
            />
            <Route
              path='/summary'
              component={() => (
                <ProtectedRoute>
                  <SummaryPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path='/waiting-for-signature'
              component={() => (
                <ProtectedRoute>
                  <WaitingForSignaturePage />
                </ProtectedRoute>
              )}
            />
            <Route
              path='/session-expired'
              component={() => <SessionExpiredPage />}
            />
            <Route
              path='/process-error'
              component={() => <ProcessErrorPage />}
            />
          </Suspense>
        </WouterRouter>
      </ConfigProvider>
    </PageLoaderProvider>
  )
}
